module.exports = __webpack_public_path__ + "static/media/MyWFUpIcon.bde09f3b.svg";